<script lang="ts">
    import { _ } from 'svelte-i18n';
    import IconFilterAlt from '../../shared/Icons/IconFilterAlt.svelte';
    import type { QueriesType } from './types';
    import IconDropdown from '../../shared/Icons/IconDropdown.svelte';

    export let filteredCount: number = 0;
    export let totalCount: number = 0;
    export let query: QueriesType = {};
    export let filterHidden: boolean = false;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="telematics-filter-icon-with-stats"
    title={$_('Show/hide filters')}
    on:click={() => {
        console.log('clicked IconFilterAlt');
        filterHidden = !filterHidden;
        if (Object.keys(query).length === 0) {
            filterHidden = false;
        }
    }}
>
    <div class="total-count">{totalCount}</div>
    {#if Object.keys(query).length > 0 || filterHidden}
        <IconFilterAlt />
        <div class="filtered-count">{filteredCount}</div>
    {/if}
    {#if filterHidden}
        <IconDropdown scale={1} />
    {/if}
</div>

<style>
    .telematics-filter-icon-with-stats {
        color: #333;
        font-size: 13px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        /*min-width: 75px;*/
        column-gap: 8px;
        cursor: pointer;
    }
    .total-count {
        font-size: 14px;
        line-height: 20px;
    }
    .filtered-count {
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
    }
</style>
